module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_link_button_calendar-0f4776ed77ed1d269593731f94987275.svg";